import { DARK_GRAY, LIGHT_BLUE, LOW_BLUE, WHITE } from "@shape/reef-shared";
import styled from "styled-components";

// TEXTS
type TextProps = {
  isUpperCase?: boolean;
};

export const CTOTitle = styled.h4<TextProps>`
  font-style: normal;
  font-weight: 700;
  font-size: 17px;
  color: ${WHITE};

  ${({ isUpperCase }) => isUpperCase && `text-transform: uppercase;`}
`;

export const CTOSubTitle = styled(CTOTitle)<TextProps>`
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
`;

export const CTOLabel = styled(CTOTitle)<TextProps>`
  margin-bottom: 8px;
  font-size: 13px;
`;

export const CTOColorfulText = styled.p<TextProps>`
  font-size: 13px;
  margin-right: auto;
  color: ${LOW_BLUE};
`;

export const CTOColorfulLabel = styled.h4<TextProps>`
  font-style: normal;
  font-weight: 700;
  font-size: 13px;
  margin-right: 8px;
  color: ${LOW_BLUE};
`;

export const CTOLongText = styled.p<TextProps>`
  font-size: 14px;
  margin: 0;
  margin-bottom: 8px;
`;

// CONTAINERS
export const CTOBox = styled.div`
  background-color: ${DARK_GRAY};
  padding: 20px;
  border-radius: 4px;
  margin-bottom: 20px;

  hr {
    border-width: 0.5px;
    margin-top: 10px;
    margin-bottom: 50px;
  }

  textarea,
  label {
    background-color: transparent;
  }
  input {
    background-color: ${DARK_GRAY};
  }
`;

export const CTORow = styled.div`
  display: flex;
  flex-wrap: nowrap;
  flex-direction: row;
  align-content: center;
  justify-content: space-between;
  align-items: center;
`;

export const CTOVerticalBox = styled.div`
  display: flex;
  flex-direction: column;

  .impl-actions-text-area {
    div div {
      width: 100%;
    }
  }
`;

export const CTOBoxBorderBlue = styled.div`
  background-color: ${DARK_GRAY};
  padding: 15px;
  border-radius: 4px;
  border-left: 10px solid ${LIGHT_BLUE};

  hr {
    border-width: 0.5px;
  }

  input,
  textarea {
    background-color: transparent;
  }
`;
